var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpouse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.286,
    height: 30.286,
    viewBox: "0 0 31.286 30.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191193",
    "data-name": "Group 191193",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176454",
    "data-name": "Group 176454",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173771",
    "data-name": "Path 173771",
    d: "M22.029,17.427a8.713,8.713,0,1,0-8.713-8.713,8.723,8.723,0,0,0,8.713,8.713m0-15.1a6.39,6.39,0,1,1-6.39,6.39,6.4,6.4,0,0,1,6.39-6.39",
    transform: "translate(-8.09)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173772",
    "data-name": "Path 173772",
    d: "M27.651,52.8q-1.713,1.707-3.423,3.423a1.24,1.24,0,0,1-.4.275H0V55.334A13.937,13.937,0,0,1,6.979,43.273a10.909,10.909,0,0,0,2.249,1.452,11.649,11.649,0,0,0-6.849,9.447H25.5a11.623,11.623,0,0,0-.3-1.7c.616-.62,1.236-1.236,1.857-1.856a13.11,13.11,0,0,1,.6,2.186",
    transform: "translate(0 -26.289)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173773",
    "data-name": "Path 173773",
    d: "M54.7,44.115a4.532,4.532,0,0,0-6.154-1.527,5.518,5.518,0,0,0-1.032.828c-.071-.067-.141-.137-.212-.2a4.512,4.512,0,0,0-6.814.659,4.348,4.348,0,0,0-.75,3.493,4.725,4.725,0,0,0,1.405,2.484q1.766,1.76,3.521,3.525Q45.686,54.4,46.7,55.423a1.24,1.24,0,0,0,.4.275,1.08,1.08,0,0,0,.809,0,1.24,1.24,0,0,0,.4-.275Q50.025,53.71,51.734,52c.75-.758,1.5-1.507,2.257-2.257a4.567,4.567,0,0,0,1.378-3.183v-.039a4.641,4.641,0,0,0-.671-2.406M52.606,48.35c-.491.487-.981.977-1.468,1.464-.62.62-1.24,1.236-1.857,1.857-.565.569-1.134,1.134-1.7,1.7l-.075.075-.075-.075q-2.449-2.461-4.906-4.914a2.825,2.825,0,0,1-.867-1.472,2.4,2.4,0,0,1,.412-1.962,2.66,2.66,0,0,1,1.079-.9,2.6,2.6,0,0,1,1.036-.2c.063,0,.133,0,.2,0a2.466,2.466,0,0,1,1.57.718c.239.224.467.459.695.691l.035.039a1.151,1.151,0,0,0,.828.369h0a1.127,1.127,0,0,0,.828-.373l.082-.086.149-.149a5.073,5.073,0,0,1,.977-.867,2.57,2.57,0,0,1,3.458.856,2.7,2.7,0,0,1,.392,1.393,2.621,2.621,0,0,1-.8,1.833",
    transform: "translate(-24.083 -25.49)",
    fill: "#f26422"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpouse);
export default __webpack_public_path__ + "static/media/spouse.73777a20edd06c5434177ecf2e340dbb.svg";
export { ForwardRef as ReactComponent };